import { Table } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { sortFormatMemberResults, calculateWinPercentage, type FormatMemberStats } from './format-stats.utils';

interface FormatStatsPanelProps {
  formatName: string;
  memberFormatTotals: Map<string | number, FormatMemberStats>;
}

export default function FormatStatsPanel({ formatName, memberFormatTotals }: FormatStatsPanelProps) {
  const memberFormatPointsSorted = [...memberFormatTotals].sort(sortFormatMemberResults);

  const memberFormatSummaryRows = memberFormatPointsSorted.map((member) => (
    <tr key={member[1].memberId}>
      <td>
        <Link to={`/members/${member[1].memberId}`}>{member[1].memberName}</Link>
      </td>
      <td>{member[1].played}</td>
      <td>{member[1].won}</td>
      <td>{member[1].halved}</td>
      <td>{member[1].lost}</td>
      <td>{Number(member[1].totalPoints)}</td>
      <td>{calculateWinPercentage(member[1])}</td>
    </tr>
  ));

  return (
    <div>
      <h3>{formatName}</h3>
      <Table>
        <thead>
          <tr>
            <th>Member</th>
            <th>Played</th>
            <th>Won</th>
            <th>½</th>
            <th>Lost</th>
            <th>Points</th>
            <th>%</th>
          </tr>
        </thead>
        <tbody>{memberFormatSummaryRows}</tbody>
      </Table>
    </div>
  );
}
